import { render, staticRenderFns } from "./ForwardEmailForm.vue?vue&type=template&id=04347740&scoped=true&"
import script from "./ForwardEmailForm.vue?vue&type=script&lang=js&"
export * from "./ForwardEmailForm.vue?vue&type=script&lang=js&"
import style0 from "./ForwardEmailForm.vue?vue&type=style&index=0&id=04347740&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04347740",
  null
  
)

export default component.exports